import get from 'transmute/get';
import { createAction } from '@reduxjs/toolkit';
import { selectThread } from '../selected-thread/actions/selectThread';
import { STUBBED_THREAD_ID } from '../threads/constants/stubbedThreadId';
import { GET_WIDGET_DATA_SUCCEEDED, RECEIVED_WIDGET_SHELL_DATA } from '../constants/VisitorActionTypes';
import { trackInteraction } from '../usage-tracking/actions/trackInteraction';
import { EVENT_NAMES } from '../usage-tracking/constants/eventNames';
// @ts-expect-error not typed
import { buildWidgetData } from '../widget-data/operators/buildWidgetData';
// @ts-expect-error not typed
import { bootstrapInitialWidgetUi } from '../initial-message-bubble/actions/bootstrapInitialWidgetUi';
// @ts-expect-error not typed
import { messageCookieHandler } from '../gdpr/operators/messageCookieHandler';
import { trackPageViewMetric } from '../usage-tracking/utils/trackMetric';

// @ts-expect-error not typed

import { getIsOpen } from '../selectors/getIsOpen';
import { getIsMobile } from '../selectors/getIsMobile';
import { getUseAskMeAnythingLauncher } from '../widget-data/selectors/widgetDataSelectors';
import { shouldShowAskMeAnythingLauncher } from '../utils/shouldShowAskMeAnythingLauncher';
export const receivedWidgetData = createAction(GET_WIDGET_DATA_SUCCEEDED, widgetData => ({
  payload: widgetData
}));
export const receivedWidgetShellData = createAction(RECEIVED_WIDGET_SHELL_DATA, widgetData => ({
  payload: widgetData
}));
export default function bootstrapWidget(data) {
  return (dispatch, getState) => {
    trackPageViewMetric();
    const widgetData = buildWidgetData(data);
    if (!get('sessionId', widgetData) || !get('chatflowId', widgetData)) {
      return;
    }
    dispatch(selectThread(STUBBED_THREAD_ID));
    messageCookieHandler({
      currentState: getState(),
      widgetData
    });
    dispatch(receivedWidgetData(widgetData));
    dispatch(receivedWidgetShellData(data));
    dispatch(bootstrapInitialWidgetUi(widgetData));
    const currentState = getState();
    const isOpen = getIsOpen(currentState);
    const mobile = getIsMobile(currentState);
    const useAskMeAnythingLauncher = getUseAskMeAnythingLauncher(currentState);
    const showAskMeAnythingLauncher = shouldShowAskMeAnythingLauncher({
      useAskMeAnythingLauncher,
      hasOpenedWidget: isOpen,
      mobile
    });
    const launcherType = showAskMeAnythingLauncher ? 'ask-me-anything' : 'icon';

    // this must be called after the recievedWidgetData, receivedWidgetShellData, and bootstrapInitialWidgetUi have been called
    dispatch(trackInteraction(EVENT_NAMES.PAGE_VIEW, {
      screen: 'widget',
      action: 'rendered widget',
      launcherType,
      isOpen
    }));
  };
}